import { useState } from 'react';
import { G500LiteAuthInfoType } from '../../feature/type/AuthInfoType';
import { initG500LiteAuthInfo } from '../../../common/const/commonConst';

/**
 * G500Liteログイン情報登録ダイアログの状態管理用カスタムフック
 */
export const useStateRegistrationDialog = (setIsRegistrationError: (value: React.SetStateAction<boolean>) => void, setG500LiteRegistrationAuthInfo: (value: React.SetStateAction<G500LiteAuthInfoType>) => void) => {
	const [isRegistrationDialogOpened, setIsRegistrationDialogOpened] = useState(false); // G500Liteログイン情報登録ダイアログの開閉状態の管理

	// ログイン情報登録ダイアログを閉じる際の処理
	const onCloseRegistrationDialog = () => {
		setIsRegistrationError(false);
		setIsRegistrationDialogOpened(false);
		setG500LiteRegistrationAuthInfo(initG500LiteAuthInfo);
	};

	return {
		isRegistrationDialogOpened,
		setIsRegistrationDialogOpened,
		onCloseRegistrationDialog,
	};
};
